// Arm A2's sub-line names the shortcut that opens Switch once the visitor is
// in the app: Cmd+J on a Mac, Ctrl+J on Windows and Linux, nothing on touch
// devices. The handoff said Cmd+K, but in the app Cmd+K opens the command
// palette; Switch's sidebar is Cmd+J / Ctrl+J (Social-Champ client-v2,
// coach-sidebar.component.ts, onCmdJ).

function switchShortcut(env) {
  const ua = (env && env.userAgent) || "";
  const platform = (env && env.platform) || "";
  const touch =
    /iPhone|iPad|iPod|Android/i.test(ua) ||
    (env &&
      env.maxTouchPoints > 1 &&
      /Mac/i.test(platform) &&
      env.coarsePointer);
  if (touch) return null;
  if (/Mac/i.test(platform) || /Macintosh/i.test(ua)) {
    return { keys: "⌘J", label: "Command J" };
  }
  return { keys: "Ctrl+J", label: "Control J" };
}

module.exports = { switchShortcut };
